import { useMemo } from 'react'
import { useCurrentOrganization } from '~publish/contexts/AccountContext'
import type { CurrentOrganization } from '~publish/contexts/AccountContext'

export function useCommonTrackingProperties(): {
  organizationId: string
} & Partial<CurrentOrganization['commonTrackingProperties']> {
  const currentOrganization = useCurrentOrganization()

  return useMemo(() => {
    const commonTrackingProperties =
      currentOrganization?.commonTrackingProperties
    return {
      organizationId: currentOrganization?.id ?? '',
      atEventBillingState: commonTrackingProperties?.atEventBillingState,
      atEventBillingPlan: commonTrackingProperties?.atEventBillingPlan,
      atEventBillingCycle: commonTrackingProperties?.atEventBillingCycle,
      atEventBillingGateway: commonTrackingProperties?.atEventBillingGateway,
      atEventIsNewBuffer: commonTrackingProperties?.atEventIsNewBuffer,
      atEventChannelQty: commonTrackingProperties?.atEventChannelQty,
    }
  }, [currentOrganization])
}
